<template>
    <Ticker />

    <nav class="navbar">
        <div class="tw-flex-shrink-0">
            <img
                src="@/assets/images/logo-marina.png"
                alt="Marina Cakes and Sweets"
                class="tw-h-16 tw-w-auto tw-cursor-pointer tw-object-contain md:tw-h-[68px]"
                @click="router.push({ name: 'Home' })" />
        </div>

        <div
            v-if="!isMobile"
            class="tw-flex tw-items-center tw-justify-center tw-gap-4">
            <v-btn
                variant="text"
                class="tw-text-secondary"
                :to="{ name: 'About' }">
                <span class="tw-text-md tw-italic">Sobre</span>
            </v-btn>

            <v-btn
                variant="text"
                class="tw-text-secondary"
                :to="{ name: 'Pitões' }">
                <span class="tw-text-md tw-italic">Pitões</span>
            </v-btn>

            <v-btn
                variant="text"
                class="tw-text-secondary"
                :to="{ name: 'Portfolio' }">
                <span class="tw-text-md tw-italic">Portefólio</span>
            </v-btn>

            <v-btn
                variant="text"
                class="tw-text-secondary"
                :to="{ name: 'Sabores' }">
                <span class="tw-text-md tw-italic">Sabores</span>
            </v-btn>
        </div>

        <div class="tw-flex-shrink-0">
            <v-btn
                v-if="!isMobile"
                variant="flat"
                :to="{ name: 'Order' }"
                class="create-cake-btn">
                Criar o meu bolo
                <v-icon size="18">mdi-arrow-top-right</v-icon>
            </v-btn>

            <v-btn
                v-if="isMobile"
                color="secondary"
                class="tw-text-primary-100 tw-text-xs"
                aria-label="Encomendar"
                @click="router.push({ name: 'Order' })">
                Encomendar
            </v-btn>

            <v-btn
                v-if="isMobile"
                variant="text"
                class="tw-text-secondary"
                aria-label="Abrir menu"
                @click="drawer = !drawer">
                <v-icon size="x-large">mdi-menu</v-icon>
            </v-btn>
        </div>
    </nav>

    <v-navigation-drawer
        v-model="drawer"
        temporary
        location="right"
        class="tw-bg-primary-100">
        <div class="tw-relative tw-flex tw-items-center tw-justify-center tw-border-b tw-border-secondary/20 tw-px-4 tw-py-6">
            <v-btn
                icon="mdi-close"
                variant="text"
                class="tw-absolute tw-left-2 tw-top-2 tw-text-secondary"
                aria-label="Fechar menu"
                @click="drawer = false"></v-btn>

            <img
                src="@/assets/images/logo-marina.jpg"
                alt="Marina Cakes and Sweets"
                class="tw-h-24 tw-w-auto tw-object-contain" />
        </div>

        <v-list
            class="tw-px-3 tw-pt-4 tw-text-secondary"
            nav>
            <v-list-item
                :to="{ name: 'About' }"
                prepend-icon="mdi-information-outline"
                title="Sobre"
                rounded="lg"
                class="tw-mb-1" />
            <v-list-item
                :to="{ name: 'Pitões' }"
                prepend-icon="mdi-map-marker-outline"
                title="Pitões"
                rounded="lg"
                class="tw-mb-1" />
            
            <v-list-item
                :to="{ name: 'Portfolio' }"
                prepend-icon="mdi-camera-outline"
                title="Portefólio"
                rounded="lg"
                class="tw-mb-1" />
            <v-list-item
                :to="{ name: 'Sabores' }"
                prepend-icon="mdi-cupcake"
                title="Sabores"
                rounded="lg"
                class="tw-mb-1" />
        </v-list>

        <template v-slot:append>
            <div class="tw-border-t tw-border-secondary/20 tw-p-4">
                <v-btn
                    block
                    :to="{ name: 'Order' }"
                    color="secondary"
                    variant="flat"
                    size="large"
                    prepend-icon="mdi-cart-outline"
                    class="tw-font-bold tw-text-primary-100">
                    Encomendar
                </v-btn>
            </div>
        </template>
    </v-navigation-drawer>

    <div class="chrome-spacer"></div>
</template>

<script lang="ts" setup>
    import { ref, computed } from 'vue';
    import { useRouter } from 'vue-router';
    import { useDisplay } from 'vuetify';
    import Ticker from '@/components/Ticker.vue';

    const router = useRouter();
    const { xs } = useDisplay();

    const isMobile = computed(() => xs.value);
    const drawer = ref(false);
</script>

<style scoped>
    .navbar {
        position: fixed;
        top: var(--ticker-h, 36px);
        left: 0;
        z-index: 50;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: var(--nav-h, 60px);
        padding: 0 1rem;
        background: #fbf6e8;
        box-shadow: 0 1px 2px rgb(78 24 36 / 0.06);
    }

    .chrome-spacer {
        height: calc(var(--ticker-h, 36px) + var(--nav-h, 80px));
    }

    @media (min-width: 768px) {
        .navbar {
            height: var(--nav-h, 88px);
            padding: 0 2rem;
        }
    }

    .navbar :deep(.create-cake-btn.v-btn) {
        height: 48px;
        padding: 0 20px 0 24px;
        border-radius: 9999px !important;
        background-color: #6e2432 !important;
        color: #fbf6e8 !important;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.01em;
        text-transform: none;
        box-shadow: 0 8px 18px rgb(110 36 50 / 0.16);
    }

    .navbar :deep(.create-cake-btn .v-btn__content) {
        gap: 14px;
    }

    .navbar :deep(.create-cake-btn .v-icon) {
        color: #fbf6e8;
    }

    @media (max-width: 600px) {
        .navbar :deep(.v-btn) {
            min-width: 40px !important;
            padding: 0 4px !important;
        }
    }
</style>

<style>
    :root {
        --ticker-h: 36px;
        --nav-h: 80px;
    }

    @media (min-width: 768px) {
        :root {
            --nav-h: 88px;
        }
    }
</style>
